import NormalFilter from '../FiltersModal/NormalFilter/NormalFilter';
import Button from '../Button/Button';
import Activity from '../../helpers/Activity';
import Viewport from '../../helpers/Viewport';
import {NormalFilterOption} from '../../models/Filter';
import './Question.css';

function Question({
    category,
    title,
    description,
    filter,
    featured,
    backgroundColor,
    filterBackgroundColor,
    filterLabelColor,
    titleLabelColor,
    descriptionLabelColor,
    closeButtonBackgroundColor,
    closeButtonLabelColor,
    checkboxBackgroundColor,
    onAnswerClick,
    onClose,
    metadata
}) {
    const viewport = Viewport.dimensions;
    const inSmallMode = viewport.width < 768;

    const handleAnswerClick = (filterId, optionId, selected) => {
        if (onAnswerClick) {
            const option = filter ? filter.options.find(o => o.id === optionId) : null;
            const optionLabel = option ? option.label : null;
            Activity.log(metadata, 'guided-selling-filter-option', optionId, selected ? 'deselect' : 'select', true, {category_id: category.id, category_name: category.name, search_query: null, filter_id: filterId, option_id: optionId, filter_label: filter.label || null, option_label: optionLabel});
            onAnswerClick(filterId, optionId, selected);
        }
    };

    const handleClose = () => {
        if (onClose) {
            Activity.log(metadata, 'guided-selling-question', 'close-button', 'close', true, {category_id: category.id, category_name: category.name, search_query: null, filter_id: filter.id, filter_label: filter.label || null});
            onClose(filter.id);
        }
    };

    const containerStyle = () => {
        return {
            margin: featured ? '20px 0 0 0' : '20px 0',
            background: backgroundColor || '#D2D8DF'
        };
    };

    const closeButtonIconContainerStyle = () => {
        return {
            background: closeButtonLabelColor || '#CD5C5C',
            color: closeButtonBackgroundColor || '#FFFFFF'
        };
    };

    const filterNameStyle = () => {
        return {
            background: filterBackgroundColor || '#4A5868',
            color: filterLabelColor || '#FFFFFF'
        };
    };

    const titleStyle = () => {
        return {
            color: titleLabelColor || '#4A4A4A'
        };
    };

    const descriptionStyle = () => {
        return {
            color: descriptionLabelColor || '#4A4A4A'
        };
    };

    const renderOptions = () => {
        const options = filter ? filter.options.sort((o1, o2) => o1.label.localeCompare(o2.label)) : [];
        let content = [];
        options.forEach((option) => {
            if (option instanceof NormalFilterOption) {
                content.push(
                    <NormalFilter
                        key={`guided-selling-filter-option-${filter.id}-${option.id}`}
                        category={category}
                        searchQuery={null}
                        filterId={filter.id}
                        optionId={option.id}
                        filterLabel={filter.label}
                        optionLabel={option.label}
                        selected={option.selected}
                        checkboxBackgroundColor={checkboxBackgroundColor}
                        onClick={handleAnswerClick}
                        ignoreMetric={true}
                        metadata={metadata}
                    />
                );
            }
        });
        return content;
    };

    return (
        <div className='question' style={containerStyle()}>
            {featured && !inSmallMode && (
                <div className='question-close-button'>
                    <Button
                        label={undefined}
                        labelColor={closeButtonLabelColor}
                        backgroundColor={closeButtonBackgroundColor}
                        borderColor={closeButtonBackgroundColor}
                        minWidth='auto'
                        maxWidth='100%'
                        boxShadow='unset'
                        padding='8px 15px'
                        borderRadius={25}
                        onClick={handleClose}
                    >
                        <div className='question-close-button-content'>
                            <div className='question-close-button-label'>Cancelar</div>
                            <div className='question-close-button-icon-container' style={closeButtonIconContainerStyle()}>
                                <div className='question-close-button-icon'>x</div>
                            </div>
                        </div>
                    </Button>
                </div>
            )}
            {featured && inSmallMode && (
                <div className='question-small-close-button' onClick={handleClose}>
                    <span className='question-small-close-button-icon'>x</span>
                </div>
            )}
            <div className='question-wrapper'>
                <div className='question-title-container'>
                    {filter.label && <div className='question-filter-name' style={filterNameStyle()}>{filter.label}</div>}
                    {title && <div className='question-title' style={titleStyle()}>{title}</div>}
                </div>
                {description && <div className='question-description' style={descriptionStyle()}>{description}</div>}
                <div className='question-answers'>
                    {renderOptions()}
                </div>
            </div>
        </div>
    );
}

export default Question;